import React from 'react';
import { GithubOutlined } from '@ant-design/icons';
import { renderBrandLogo } from './providerLogos/brandSvgs';

/**
 * Theme-aware logo wrapper for Create Project provider tiles.
 * @param {string} id - Provider key (openai, s3, github, milvus, …)
 */
export default function ProviderLogo({ id, className = '' }) {
  const content = id === 'github'
    ? <GithubOutlined className="provider-logo-github" />
    : renderBrandLogo(id);

  if (!content) return null;

  return (
    <div className={`logo-container ${className}`.trim()} aria-hidden>
      {content}
    </div>
  );
}
